/* eslint-disable react-hooks/exhaustive-deps */
import React from 'react';
import Box from '@material-ui/core/Box';
import Typography from '@material-ui/core/Typography';
import CurrencyFormat from 'react-currency-format';
import {makeStyles} from '@material-ui/core/styles';

const useStyles = makeStyles({
  shopCard: {
    border: '1px solid #70707033',
  },
  product: {
    maxHeight: 70,
    height: '100%',
  },
  subtitleProduct: {
    fontWeight: 500,
  },
});

export function ViewTotals(props) {
  const classes = useStyles();

  return (
    <div className={classes.shopCard}>
      <Box display="flex" justifyContent="space-between" py={2} px={2}>
        <Typography variant="body2">Total:</Typography>
        <CurrencyFormat
          value={props.value}
          displayType={'text'}
          thousandSeparator={true}
          prefix={'$'}
          renderText={(value) => (
            <Typography variant="body2">{value}</Typography>
          )}
        />
      </Box>
    </div>
  );
}
